import { Alert } from 'flowbite-react';

const Unavailable = () => {
  return (
    <div className="flex flex-col gap-4">
      <Alert color="info">
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Вход недоступен</h3>
          <p className="text-sm">
            Система авторизации временно недоступна. Попробуйте позже или
            обратитесь к технической поддержке.
          </p>
        </div>
      </Alert>
    </div>
  );
};

export { Unavailable };
